import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-required-field',
  templateUrl: './required-field.component.html',
  styleUrls: []
})
export class RequiredFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
